export default function SetEnv(data) {
  return {
    type: 'ENV',
    env: data || {},
  };
}
